var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: { value: _vm.isOpen },
      on: {
        hide: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("Card", { staticClass: "add-modal-card" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("\n      Добавить магазин по номеру\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [_c("q-input", { attrs: { dense: "", outlined: "" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row reverse" },
          [
            _c("q-btn", {
              attrs: {
                type: "submit",
                size: "16px",
                label: "Добавить",
                unelevated: "",
                color: "primary"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }